var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 185,
    viewBox: "0 0 229 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6577:19478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.3656 0L21.2232 29.4535H24.28V53.4717H8.87493L0 70.734L109.967 126.958L146.333 56.2244L36.3656 0Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.761 19.1599H33.1685V103.51H201.761V19.1599Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M181.261 49.4685H56.8232V49.7544H181.261V49.4685Z",
    fill: "#575758"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M181.404 56.6169H56.9663V56.9029H181.404V56.6169Z",
    fill: "#575758"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M181.404 70.9136H56.9663V71.1995H181.404V70.9136Z",
    fill: "#575758"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M181.404 77.2039H56.9663V77.4898H181.404V77.2039Z",
    fill: "#575758"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M181.404 63.7651H56.9663V64.0511H181.404V63.7651Z",
    fill: "#575758"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.48 185C191.934 185 215.811 182.824 215.811 180.139C215.811 177.455 191.934 175.278 162.48 175.278C133.027 175.278 109.15 177.455 109.15 180.139C109.15 182.824 133.027 185 162.48 185Z",
    fill: "#3F3D56",
    fillOpacity: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4186 77.4111L60.0229 76.9971L78.5455 59.3914L94.8732 71.1038L108.077 56.5053L113.867 61.413L129.616 51.9893L147.11 63.715L174.567 48.1406L174.851 48.6376L147.085 64.3872L129.599 52.6666L113.809 62.1144L108.13 57.3004L94.9552 71.8669L78.5966 60.1329L60.4186 77.4111Z",
    fill: "url(#paint0_linear_6577:19478)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.759 170.371C115.107 175.339 119.722 178.416 119.722 178.416C119.722 178.416 122.153 173.438 120.806 168.47C119.458 163.502 114.842 160.426 114.842 160.426C114.842 160.426 112.411 165.403 113.759 170.371Z",
    fill: "#A0AEC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.739 169.304C119.437 172.893 119.888 178.412 119.888 178.412C119.888 178.412 114.345 178.11 110.647 174.52C106.949 170.93 106.498 165.412 106.498 165.412C106.498 165.412 112.041 165.714 115.739 169.304Z",
    fill: "#D14358"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M219.395 24.8786C224.7 24.8786 229 20.5901 229 15.2999C229 10.0097 224.7 5.72119 219.395 5.72119C214.09 5.72119 209.79 10.0097 209.79 15.2999C209.79 20.5901 214.09 24.8786 219.395 24.8786Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M201.618 26.594C205.339 26.594 208.356 23.5857 208.356 19.8747C208.356 16.1636 205.339 13.1553 201.618 13.1553C197.897 13.1553 194.88 16.1636 194.88 19.8747C194.88 23.5857 197.897 26.594 201.618 26.594Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M193.303 146.685C195.283 146.685 196.887 145.085 196.887 143.111C196.887 141.137 195.283 139.537 193.303 139.537C191.324 139.537 189.719 141.137 189.719 143.111C189.719 145.085 191.324 146.685 193.303 146.685Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M132.231 164.413C133.736 164.413 134.955 163.197 134.955 161.697C134.955 160.196 133.736 158.98 132.231 158.98C130.727 158.98 129.507 160.196 129.507 161.697C129.507 163.197 130.727 164.413 132.231 164.413Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M123.056 129.244C125.036 129.244 126.64 127.643 126.64 125.669C126.64 123.695 125.036 122.095 123.056 122.095C121.077 122.095 119.472 123.695 119.472 125.669C119.472 127.643 121.077 129.244 123.056 129.244Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.379 53.3287C176.438 53.3287 178.107 51.6645 178.107 49.6116C178.107 47.5587 176.438 45.8945 174.379 45.8945C172.321 45.8945 170.652 47.5587 170.652 49.6116C170.652 51.6645 172.321 53.3287 174.379 53.3287Z",
    fill: "#43D1B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.16 116.939L147.001 117.289C147.001 117.289 145.596 123.591 147.001 131.994C148.405 140.397 150.16 148.8 150.16 148.8C150.16 148.8 151.565 176.109 152.267 176.46C152.969 176.81 159.289 178.91 159.64 176.81C159.991 174.709 159.991 126.742 159.991 126.742L164.906 149.85C164.906 149.85 165.609 178.91 167.013 178.91C168.417 178.91 172.981 178.56 172.981 176.109C172.981 173.659 174.035 141.447 174.035 141.447C174.035 141.447 173.684 117.639 172.279 116.939C170.875 116.238 150.16 116.939 150.16 116.939Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.97 175.409C152.97 175.409 149.81 175.059 149.108 175.409C148.405 175.759 147.352 178.21 149.108 179.61C150.863 181.011 155.427 183.112 156.832 183.112C157.806 183.069 158.761 182.83 159.64 182.411L158.938 176.459L152.97 175.409Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.013 177.16L167.364 182.062C167.364 182.062 171.928 182.762 172.28 182.062C172.631 181.361 176.142 179.611 176.493 179.261C176.844 178.91 177.195 175.059 175.088 174.709C172.982 174.359 172.28 175.409 172.28 175.409L167.013 177.16Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.521 87.5283C137.521 87.5283 129.095 95.5812 130.148 99.7826C131.202 103.984 139.628 116.238 139.628 116.238C139.628 116.238 147.703 120.44 148.756 116.238C149.809 112.037 143.139 113.087 143.139 113.087L137.872 100.483L143.841 92.0799L137.521 87.5283Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.172 75.2768C175.172 75.2768 182.848 70.3543 182.67 66.9725C182.493 63.5906 177.865 52.9276 177.865 52.9276C177.865 52.9276 174.245 45.4221 172.806 48.4894C171.367 51.5568 174.697 54.8219 174.697 54.8219L176.847 65.2819L171.005 70.84L175.172 75.2768Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.129 68.2714C159.619 68.2714 162.449 65.4498 162.449 61.9692C162.449 58.4886 159.619 55.667 156.129 55.667C152.639 55.667 149.81 58.4886 149.81 61.9692C149.81 65.4498 152.639 68.2714 156.129 68.2714Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.969 65.8205L154.023 72.4729L161.747 71.0724C161.747 71.0724 161.395 64.4201 161.395 63.7198C161.395 63.0196 152.969 65.8205 152.969 65.8205Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.618 72.4728C152.618 72.4728 161.395 70.3721 162.449 71.0724C163.502 71.7726 168.768 72.4728 168.768 72.4728L174.737 81.576L172.982 93.1301C172.982 93.1301 172.63 111.687 173.333 114.838C174.035 117.989 177.897 118.339 169.822 119.039C161.747 119.739 160.342 118.689 154.725 120.09C149.107 121.49 144.543 119.389 145.947 117.989C147.352 116.588 149.809 94.1805 147.001 92.0797C144.192 89.979 143.139 79.1252 143.139 79.1252C143.139 79.1252 152.618 74.2235 152.618 72.4728Z",
    fill: "#D14358"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.715 73.5232L168.769 72.4728L170.875 70.3721C170.875 70.3721 177.721 73.3481 177.37 74.3985C177.019 75.4489 174.737 81.576 174.737 81.576L171.577 82.6264L167.715 73.5232Z",
    fill: "#D14358"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.352 79.8255L143.139 79.1252C143.139 79.1252 139.979 82.6265 138.925 84.027C137.872 85.4275 135.766 88.9287 135.766 88.9287L143.139 94.1805L148.756 88.2284L147.352 79.8255Z",
    fill: "#D14358"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.335 54.334L158.27 53.8291C157.84 53.8267 157.413 53.8936 157.005 54.0273C156.963 53.7229 156.99 53.413 157.083 53.1201C156.669 53.2264 156.273 53.3978 155.913 53.6277L155.657 52.7063L152.147 54.4313C150.888 55.0505 149.559 55.7309 148.839 56.9335C148.036 58.2741 148.176 59.9971 148.725 61.4596C149.274 62.9221 150.186 64.2164 150.917 65.5973C151.194 66.1911 151.528 66.7573 151.913 67.2881C153.238 68.9351 155.817 69.2678 157.684 68.2738C158.395 67.9323 158.962 67.3509 159.284 66.6326C159.42 66.187 159.527 65.733 159.603 65.2734C159.834 64.3323 160.102 62.3895 160.869 61.7941C161.206 61.5321 161.875 62.4007 162.155 62.0781C162.873 61.2489 162.722 59.9703 162.276 58.969C161.848 57.9633 161.347 56.9897 160.778 56.056C160.537 55.6806 158.327 54.2735 158.335 54.334Z",
    fill: "url(#paint1_linear_6577:19478)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9865 32.8845H3.63623V51.1841H21.9865V32.8845Z",
    fill: "#43D1B7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6577:19478",
    x1: 68.5,
    y1: 71,
    x2: 172.5,
    y2: 53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C63FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29C6C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6577:19478",
    x1: 155.463,
    y1: 52.7063,
    x2: 155.463,
    y2: 68.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2E41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#332AD8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6577:19478"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 229,
    height: 185,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinance);
export default __webpack_public_path__ + "static/media/finance.f2741ede.svg";
export { ForwardRef as ReactComponent };